// Simulator i18n content — kept separate to avoid bloating translations.js.
// Loaded by SimulatorPage via useLanguage().lang.

export const SIMULATOR_I18N = {
  es: {
    nav_btn: "Market Simulator™",
    nav_badge: "NEW",
    eyebrow: "Live Simulation Engine",
    title: "RE₿EL MARKET",
    title_em: "SIMULATOR™",
    subtitle: "La mayoría estudia el mercado. Los traders RE₿EL lo SOBREVIVEN.",
    cta_free: "Probar gratis · 1 simulación",
    cta_pro: "Acceso completo · €39.90",
    cta_note: "Pago único · Incluye Academia RE₿EL completa · Lifetime",
    free_used: "Ya has usado tu simulación gratis",
    pro_active: "Acceso PRO activo · Simulaciones ilimitadas",
    open_play: "Lanzar simulador →",
    stats: [
      { value: "6", label: "Modos de simulación" },
      { value: "4", label: "Escenarios históricos" },
      { value: "87%", label: "Precisión IA Mentor" },
      { value: "12", label: "Eventos históricos" },
    ],
    modes_title: "Modos de simulación",
    modes_subtitle: "Cuatro motores. Una sola misión: forjar disciplina institucional.",
    modes: [
      {
        title: "Historical Survival Mode™",
        desc: "Revive eventos históricos cripto en tiempo real. FTX collapse, Bitcoin ETF, COVID crash, liquidation cascades.",
        badge: "FREE",
      },
      {
        title: "Smart Money Trap Mode™",
        desc: "La IA crea trampas institucionales. Detecta fake breakouts, stop hunts y manipulación de liquidez.",
        badge: "PRO",
      },
      {
        title: "Psychology Stress Test™",
        desc: "Alta volatilidad, señales falsas, presión extrema. ¿Puedes mantener la disciplina cuando el mercado enloquece?",
        badge: "PRO",
      },
      {
        title: "Institutional Decision Mode™",
        desc: "Piensa como el dinero inteligente. Cada decisión evaluada desde perspectiva institucional.",
        badge: "PRO",
      },
    ],
    dna_title: "Descubre tu Trader DNA™",
    dna_subtitle: "La IA analiza tus decisiones y construye tu perfil psicológico de trading completo.",
    dna_metrics: [
      "Estabilidad Emocional",
      "Gestión de Riesgo",
      "Disciplina Operativa",
      "Smart Money IQ",
      "Resiliencia Psicológica",
      "Timing Institucional",
    ],
    cta_eyebrow: "Acceso completo",
    cta_price_old: "€49.90",
    cta_price_new: "€39.90",
    cta_note_final: "Acceso de por vida · Incluye Academia RE₿EL · Sin suscripción",
    cta_btn_final: "Activar Simulator PRO",
    paywall_title: "Desbloquea el Simulator completo",
    paywall_features: [
      "4 modos de simulación completos",
      "12 escenarios históricos reales",
      "IA Mentor ilimitada en tiempo real",
      "Trader DNA™ completo con análisis IA",
      "Historial y ranking institucional",
    ],
    paywall_close: "Cerrar",
    login_required: "Inicia sesión para empezar",
  },
  en: {
    nav_btn: "Market Simulator™",
    nav_badge: "NEW",
    eyebrow: "Live Simulation Engine",
    title: "RE₿EL MARKET",
    title_em: "SIMULATOR™",
    subtitle: "Most traders study the market. RE₿EL traders SURVIVE it.",
    cta_free: "Free trial · 1 simulation",
    cta_pro: "Full access · €39.90",
    cta_note: "One-time payment · Includes full RE₿EL Academy · Lifetime",
    free_used: "You've used your free simulation",
    pro_active: "PRO access active · Unlimited simulations",
    open_play: "Launch simulator →",
    stats: [
      { value: "6", label: "Simulation modes" },
      { value: "4", label: "Historical scenarios" },
      { value: "87%", label: "AI Mentor accuracy" },
      { value: "12", label: "Historical events" },
    ],
    modes_title: "Simulation modes",
    modes_subtitle: "Four engines. One mission: forge institutional discipline.",
    modes: [
      {
        title: "Historical Survival Mode™",
        desc: "Relive historical crypto events in real time. FTX collapse, Bitcoin ETF, COVID crash, liquidation cascades.",
        badge: "FREE",
      },
      {
        title: "Smart Money Trap Mode™",
        desc: "AI builds institutional traps. Detect fake breakouts, stop hunts and liquidity manipulation.",
        badge: "PRO",
      },
      {
        title: "Psychology Stress Test™",
        desc: "High volatility, false signals, extreme pressure. Can you stay disciplined when the market goes mad?",
        badge: "PRO",
      },
      {
        title: "Institutional Decision Mode™",
        desc: "Think like smart money. Every decision evaluated from an institutional perspective.",
        badge: "PRO",
      },
    ],
    dna_title: "Discover your Trader DNA™",
    dna_subtitle: "AI analyses your decisions and builds your complete trading psychology profile.",
    dna_metrics: [
      "Emotional Stability",
      "Risk Management",
      "Operating Discipline",
      "Smart Money IQ",
      "Psychological Resilience",
      "Institutional Timing",
    ],
    cta_eyebrow: "Full access",
    cta_price_old: "€49.90",
    cta_price_new: "€39.90",
    cta_note_final: "Lifetime access · Includes RE₿EL Academy · No subscription",
    cta_btn_final: "Activate Simulator PRO",
    paywall_title: "Unlock the full Simulator",
    paywall_features: [
      "4 complete simulation modes",
      "12 real historical scenarios",
      "Unlimited real-time AI Mentor",
      "Full Trader DNA™ with AI analysis",
      "History and institutional ranking",
    ],
    paywall_close: "Close",
    login_required: "Sign in to start",
  },
  sk: {
    nav_btn: "Market Simulator™",
    nav_badge: "NEW",
    eyebrow: "Live Simulation Engine",
    title: "RE₿EL MARKET",
    title_em: "SIMULATOR™",
    subtitle: "Väčšina traderov študuje trh. RE₿EL traderi ho PREŽIJÚ.",
    cta_free: "Skúšaj zdarma · 1 simulácia",
    cta_pro: "Plný prístup · €39.90",
    cta_note: "Jednorazová platba · Zahŕňa celú RE₿EL Akadémiu · Doživotne",
    free_used: "Bezplatnú simuláciu si už použil",
    pro_active: "PRO prístup aktívny · Neobmedzené simulácie",
    open_play: "Spustiť simulátor →",
    stats: [
      { value: "6", label: "Režimov simulácie" },
      { value: "4", label: "Historických scenárov" },
      { value: "87%", label: "Presnosť AI Mentora" },
      { value: "12", label: "Historických udalostí" },
    ],
    modes_title: "Režimy simulácie",
    modes_subtitle: "Štyri motory. Jedna misia: vykovať inštitucionálnu disciplínu.",
    modes: [
      {
        title: "Historical Survival Mode™",
        desc: "Prežij historické krypto udalosti v reálnom čase. FTX kolaps, Bitcoin ETF, COVID crash, likvidačné kaskády.",
        badge: "FREE",
      },
      {
        title: "Smart Money Trap Mode™",
        desc: "AI tvorí inštitucionálne pasce. Odhaľ falošné breakouty, stop hunty a manipuláciu likvidity.",
        badge: "PRO",
      },
      {
        title: "Psychology Stress Test™",
        desc: "Vysoká volatilita, falošné signály, extrémny tlak. Udržíš disciplínu, keď trh zošalie?",
        badge: "PRO",
      },
      {
        title: "Institutional Decision Mode™",
        desc: "Mysli ako smart money. Každé rozhodnutie hodnotené z inštitucionálneho pohľadu.",
        badge: "PRO",
      },
    ],
    dna_title: "Objav svoju Trader DNA™",
    dna_subtitle: "AI analyzuje tvoje rozhodnutia a vytvorí kompletný psychologický profil obchodníka.",
    dna_metrics: [
      "Emocionálna stabilita",
      "Riadenie rizika",
      "Operatívna disciplína",
      "Smart Money IQ",
      "Psychologická odolnosť",
      "Inštitucionálne načasovanie",
    ],
    cta_eyebrow: "Plný prístup",
    cta_price_old: "€49.90",
    cta_price_new: "€39.90",
    cta_note_final: "Doživotný prístup · Zahŕňa RE₿EL Akadémiu · Bez predplatného",
    cta_btn_final: "Aktivovať Simulator PRO",
    paywall_title: "Odomkni celý Simulator",
    paywall_features: [
      "4 kompletné režimy simulácie",
      "12 reálnych historických scenárov",
      "Neobmedzený AI Mentor v reálnom čase",
      "Kompletná Trader DNA™ s AI analýzou",
      "História a inštitucionálny ranking",
    ],
    paywall_close: "Zavrieť",
    login_required: "Prihlás sa pre štart",
  },
  "zh-CN": {
    nav_btn: "Market Simulator™",
    nav_badge: "NEW",
    eyebrow: "实时模拟引擎",
    title: "RE₿EL MARKET",
    title_em: "SIMULATOR™",
    subtitle: "大多数人研究市场。RE₿EL交易者在市场中生存。",
    cta_free: "免费试用 · 1次模拟",
    cta_pro: "完整访问 · €39.90",
    cta_note: "一次性付款 · 包含完整RE₿EL学院 · 终身访问",
    free_used: "你已使用免费模拟",
    pro_active: "PRO访问已激活 · 无限模拟",
    open_play: "启动模拟器 →",
    stats: [
      {
        value: "6",
        label: "模拟模式",
      },
      {
        value: "4",
        label: "历史场景",
      },
      {
        value: "87%",
        label: "AI导师精准度",
      },
      {
        value: "12",
        label: "历史事件",
      }
    ],
    modes_title: "模拟模式",
    modes_subtitle: "四个引擎。一个使命：锻造机构级纪律。",
    modes: [
      {
        title: "Historical Survival Mode™",
        desc: "实时重现加密货币历史事件。FTX崩盘、Bitcoin ETF、COVID暴跌、连环爆仓。",
        badge: "FREE",
      },
      {
        title: "Smart Money Trap Mode™",
        desc: "AI创建机构陷阱。识别假突破、猎杀止损和流动性操纵。",
        badge: "PRO",
      },
      {
        title: "Psychology Stress Test™",
        desc: "高波动、假信号、极端压力。当市场疯狂时，你能保持纪律吗？",
        badge: "PRO",
      },
      {
        title: "Institutional Decision Mode™",
        desc: "像机构资金一样思考。每个决策从机构视角评估。",
        badge: "PRO",
      }
    ],
    dna_title: "发现你的Trader DNA™",
    dna_subtitle: "AI分析你的决策并构建完整的交易心理画像。",
    dna_metrics: [
      "情绪稳定性",
      "风险管理",
      "操作纪律",
      "Smart Money IQ",
      "心理韧性",
      "机构级时机把握"
    ],
    cta_eyebrow: "完整访问",
    cta_price_old: "€49.90",
    cta_price_new: "€39.90",
    cta_note_final: "终身访问 · 包含RE₿EL学院 · 无需订阅",
    cta_btn_final: "激活Simulator PRO",
    paywall_title: "解锁完整Simulator",
    paywall_features: [
      "4个完整模拟模式",
      "12个真实历史场景",
      "无限实时AI导师",
      "完整Trader DNA™及AI分析",
      "历史记录和机构排名"
    ],
    paywall_close: "关闭",
    login_required: "登录开始",
  },
  de: {
    nav_btn: "Market Simulator™",
    nav_badge: "NEU",
    eyebrow: "Live Simulation Engine",
    title: "RE₿EL MARKET",
    title_em: "SIMULATOR™",
    subtitle: "Die meisten studieren den Markt. RE₿EL-Trader ÜBERLEBEN ihn.",
    cta_free: "Kostenlos testen · 1 Simulation",
    cta_pro: "Vollzugang · €39.90",
    cta_note: "Einmalzahlung · Inkl. vollständiger RE₿EL Academy · Lifetime",
    free_used: "Du hast deine kostenlose Simulation bereits genutzt",
    pro_active: "PRO-Zugang aktiv · Unbegrenzte Simulationen",
    open_play: "Simulator starten →",
    stats: [
      {
        value: "6",
        label: "Simulationsmodi",
      },
      {
        value: "4",
        label: "Historische Szenarien",
      },
      {
        value: "87%",
        label: "KI-Mentor-Präzision",
      },
      {
        value: "12",
        label: "Historische Events",
      }
    ],
    modes_title: "Simulationsmodi",
    modes_subtitle: "Vier Engines. Eine Mission: institutionelle Disziplin schmieden.",
    modes: [
      {
        title: "Historical Survival Mode™",
        desc: "Erlebe historische Krypto-Events in Echtzeit. FTX-Kollaps, Bitcoin-ETF, COVID-Crash, Liquidation-Kaskaden.",
        badge: "GRATIS",
      },
      {
        title: "Smart Money Trap Mode™",
        desc: "Die KI erschafft institutionelle Fallen. Erkenne Fake-Breakouts, Stop-Hunts und Liquiditätsmanipulation.",
        badge: "PRO",
      },
      {
        title: "Psychology Stress Test™",
        desc: "Hohe Volatilität, falsche Signale, extremer Druck. Kannst du die Disziplin bewahren, wenn der Markt durchdreht?",
        badge: "PRO",
      },
      {
        title: "Institutional Decision Mode™",
        desc: "Denke wie Smart Money. Jede Entscheidung aus institutioneller Perspektive bewertet.",
        badge: "PRO",
      }
    ],
    dna_title: "Entdecke deine Trader DNA™",
    dna_subtitle: "Die KI analysiert deine Entscheidungen und erstellt dein vollständiges Trading-Psychologieprofil.",
    dna_metrics: [
      "Emotionale Stabilität",
      "Risikomanagement",
      "Operative Disziplin",
      "Smart Money IQ",
      "Psychologische Resilienz",
      "Institutionelles Timing"
    ],
    cta_eyebrow: "Vollzugang",
    cta_price_old: "€49.90",
    cta_price_new: "€39.90",
    cta_note_final: "Lebenslanger Zugang · Inkl. RE₿EL Academy · Kein Abo",
    cta_btn_final: "Simulator PRO aktivieren",
    paywall_title: "Schalte den vollständigen Simulator frei",
    paywall_features: [
      "4 vollständige Simulationsmodi",
      "12 echte historische Szenarien",
      "Unbegrenzte KI-Mentor-Echtzeit",
      "Vollständige Trader DNA™ mit KI-Analyse",
      "Historie und institutionelles Ranking"
    ],
    paywall_close: "Schließen",
    login_required: "Melde dich an, um zu starten",
  },
};

export const useSimulatorI18n = (lang) => SIMULATOR_I18N[lang] || SIMULATOR_I18N.es;
